
<ng-container *ngIf="showExportFeature && showBtn">
  <div (click)="openPopup()">
    <div #ref><ng-content></ng-content></div>
    <span *ngIf="ref.children.length == 0">
      <button class="btn-ghost">
        <app-icon name="download" [size]="15" [strokeWidth]="2"></app-icon>
        <span>{{textButton}}</span>
      </button>
    </span>
  </div>
</ng-container>

<!-- add note popup -->
<p-dialog [dismissableMask]="true" [(visible)]="showExportPopUp" (onHide)="onHide()" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false" [styleClass]="'add-opportunity-form'" (click)="closeModalOutside($event)" [closable]="false">
  <ng-template pTemplate="content">
    <div class="container-export-popup content-dialog" (click)="$event.stopPropagation()">
        <div class="header">
            <h2>Export All Records</h2>
            <div class="close-popup" (click)="closeModalOutside($event)">
                <img src="./assets/images/ic-close.svg" alt="ic-close">
            </div>
        </div>
        <form [formGroup]="exportForm" #form="ngForm" (ngSubmit)="save()" novalidate>
            <div class="form-group">
                <label for="" class="form-label">
                    Select the columns you want to include in your export file. You can choose from the following columns
                    <i *ngIf="isLoading" class="fa-spin fas fa-spinner ms-2"></i>
                </label>
                <p-multiSelect
                [options]="columns"
                [disabled]="isLoading"
                optionLabel="name"
                formControlName="columns"
                (onChange)="onChangeDrop($event)"
                ></p-multiSelect>
                <app-form-errors
                [color]="'danger'"
                [form]="form"
                [control]="exportForm.controls['columns']"
                >
                </app-form-errors>
            </div>
            <div class="form-group">
                <label for="" class="form-label">
                    Format
                </label>
                <p-dropdown formControlName="format"
                [options]="formats" optionLabel="name" [showClear]="true"></p-dropdown>
                <app-form-errors
                [color]="'danger'"
                [form]="form"
                [control]="exportForm.controls['columns']"
                >
                </app-form-errors>
            </div>

            <div class="d-flex" style="gap: 10px;">
                <p-checkbox formControlName="isSelectAllColumns" [binary]="true" inputId="binary" (onChange)="onChangeCheckBox($event)"></p-checkbox>
                <div class="no-lienholder">All Columns</div>
            </div>
            <div class="footer-form">
                <button class="cancel-btn" type="button" [disabled]="loadingSubmit" (click)="closeModalOutside($event)">Cancel</button>
                <button [disabled]="loadingSubmit" type="submit" class="create-btn custom-btn">
                    Export Now
                    <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
                </button>
            </div>
        </form>
    </div>
  </ng-template>
</p-dialog>


<!-- confirmation message -->
<app-confirmation-msg
  class="conformation"
  #messageComponent
  [isLoading]="loadingConfirm"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to discard your data?'"
>
</app-confirmation-msg>
